import { ComponentProps } from "react";

import { Step } from "../../../../types/Step";
import AppContextValueProvider from "../../../App/Compositions/AppContextValueProvider";
import { IStepWrapperButtonProps } from "../../Components/StepWrapper";
import FormSeriesMedicalStep, { IMedicalStepProps } from "../Components/FormSeriesMedicalStep";
import { DiabeticFormEvaluator, diabeticFormQuestions } from "./ComposedDiabeticMedicalQuestions";
import ComposedUseCreateMedicalNonCanLeadResult from "./ComposedUseCreateMedicalNonCanLeadResult";

const ConfiguredDiabeticMedicalStep: React.FC<IMedicalStepProps & IStepWrapperButtonProps> = props =>
  FormSeriesMedicalStep({
    ...props,
    nextStep: Step.scheduling,
    medicalQualificationEvaluator: DiabeticFormEvaluator,
    FormQuestions: diabeticFormQuestions,
    useCreateNonCandidateLeadResult: ComposedUseCreateMedicalNonCanLeadResult
  });

const ComposedDiabeticMedicalStep: React.FC<IStepWrapperButtonProps> = AppContextValueProvider<
  IMedicalStepProps,
  ComponentProps<typeof ConfiguredDiabeticMedicalStep>
>({
  Component: ConfiguredDiabeticMedicalStep,
  map: ({ medicalForm, router, setMedicalConclusions, setMedicalForm, triggerSaveCustomerNote }) => ({
    router,
    value: medicalForm,
    onMedicalNoncandidateDisqualification: triggerSaveCustomerNote,
    setMedicalConclusions,
    setMedicalFormState: setMedicalForm
  })
});

export default ComposedDiabeticMedicalStep;
